import { Component, Input } from '@angular/core';

import { Toast } from 'ngx-toastr';

import type { AlertType } from './contracts/alert.types';
import { AlertComponent } from './alert.component';

@Component({
	selector: 'vp-alert-toastr',
	imports: [AlertComponent],
	template: `
		<vp-alert
			[closeable]="closeable"
			[content]="content"
			[emphasized]="emphasized"
			[hasElevation]="hasElevation"
			[isToastr]="true"
			[size]="size"
			[title]="message()"
			[type]="type"
			(closeEmitter)="remove()"
		/>
	`,
})
export class AlertToastrComponent extends Toast {
	@Input() content = '';
	@Input() closeable = false;
	@Input() emphasized = false;
	@Input() hasElevation = false;
	@Input() type: AlertType = 'dialog--info';
	@Input() size: 'base' | 'small' = 'base';

	constructor() {
		super();
	}
}
